import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';
import { categoryColorMap } from '@/mocks/categories';

interface VideoCardProps {
  video: Video;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  const colorStyle = categoryColorMap[video.categoryColor] || categoryColorMap.primary;
  const isLarge = size === 'large';

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Link
      to={`/article/${video.id}`}
      onClick={handleClick}
      className="group block cursor-pointer"
    >
      <article className="bg-white rounded-lg overflow-hidden border border-background-200/70 hover:border-background-300 transition-all duration-300">
        <div className={`relative ${isLarge ? 'aspect-video' : 'aspect-video'}`}>
          <img
            src={video.thumbnail}
            alt={video.title}
            title={`17c·moc起草糖心在线看 - ${video.title}`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
          <span className="absolute bottom-2 right-2 bg-black/75 text-white text-xs px-2 py-0.5 rounded">
            {video.duration}
          </span>
          {video.isHot && (
            <span className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
              热门
            </span>
          )}
          {video.isNew && (
            <span className="absolute top-2 left-16 bg-accent-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
              最新
            </span>
          )}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
              <i className="ri-play-fill text-primary-500 text-2xl" style={{ width: '28px', height: '28px' }}></i>
            </div>
          </div>
        </div>
        <div className={`${isLarge ? 'p-4 md:p-5' : 'p-3 md:p-4'}`}>
          <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 ${isLarge ? 'text-base md:text-lg' : 'text-sm md:text-base'}`}>
            {video.title}
          </h3>
          {isLarge && (
            <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
              {video.description}
            </p>
          )}
          <div className={`flex items-center justify-between ${isLarge ? 'mt-3' : 'mt-2'}`}>
            <span className={`inline-flex items-center gap-1 ${colorStyle.bg} ${colorStyle.text} text-xs px-2 py-0.5 rounded-full`}>
              <i className="ri-folder-line" style={{ width: '12px', height: '12px' }}></i>
              {video.categoryName}
            </span>
            <div className="flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-eye-line" style={{ width: '12px', height: '12px' }}></i>
                </div>
                {video.views > 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views.toLocaleString()}
              </span>
              <span className="flex items-center gap-1">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-star-fill text-accent-500" style={{ width: '12px', height: '12px' }}></i>
                </div>
                {video.rating}
              </span>
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}